import { Component, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { BreadcrumbItem, BreadcrumbService } from './breadcrumb.service';

const HIDDEN_BREADCRUMBS = new Set(['Configuración', 'Documentación KYC Paycomet']);

const ROUTE_SECTION_MAP: { prefix: string; section: string }[] = [
  { prefix: '/campaigns_new', section: 'MENU.CAMPAIGNS_MANAGER' },
  { prefix: '/campaigns', section: 'MENU.CAMPAIGNS_MANAGER' },
  { prefix: '/portfolios', section: 'MENU.CAMPAIGNS_MANAGER' },
  { prefix: '/copy', section: 'MENU.CAMPAIGNS_MANAGER' },
  { prefix: '/segments', section: 'MENU.CAMPAIGNS_MANAGER' },
  { prefix: '/customers', section: 'MENU.OPERATIVA' },
  { prefix: '/instances', section: 'MENU.OPERATIVA' },
  { prefix: '/operations', section: 'MENU.OPERATIVA' },
  { prefix: '/payments', section: 'MENU.OPERATIVA' },
  { prefix: '/outbound-calls', section: 'MENU.OPERATIVA' },
  { prefix: '/chat-conversations', section: 'MENU.OPERATIVA' },
  { prefix: '/payment-agreement', section: 'MENU.OPERATIVA' },
  { prefix: '/collectors', section: 'MENU.ADMINISTRATION' },
  { prefix: '/brands', section: 'MENU.ADMINISTRATION' },
  { prefix: '/channel-configs', section: 'MENU.ADMINISTRATION' },
  { prefix: '/feedback-configs', section: 'MENU.ADMINISTRATION' },
  { prefix: '/payment-methods', section: 'MENU.ADMINISTRATION' },
  { prefix: '/users', section: 'MENU.ADMINISTRATION' },
  { prefix: '/tax-entity', section: 'MENU.ADMINISTRATION' },
  { prefix: '/services', section: 'MENU.ADMINISTRATION' },
  { prefix: '/regional-configs', section: 'MENU.ADMINISTRATION' },
  { prefix: '/event-hooks', section: 'MENU.ADMINISTRATION' },
  { prefix: '/phases', section: 'MENU.ADMINISTRATION' },
];

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './app.breadcrumb.component.html',
  styleUrls: ['../../../assets/layout/styles/layout/_breadcrumb.scss'],
})
export class AppBreadcrumbComponent implements OnDestroy {
  hiddenNav = false;
  hiddenTitle = false;
  private sub!: Subscription;

  constructor(
    private router: Router,
    readonly breadcrumbService: BreadcrumbService,
  ) {
    this.sub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e) => {
      const root = this.router.routerState.snapshot.root;
      const items: BreadcrumbItem[] = [];
      this.buildItems(root, [], items);
      this.hiddenNav = this.routeHasFlag(root, 'hideBreadcrumb');
      this.hiddenTitle = this.routeHasFlag(root, 'hideTitle');

      if (items.length === 1) {
        const url = (e as NavigationEnd).urlAfterRedirects.split('?')[0];
        const match = ROUTE_SECTION_MAP.find((entry) => url.startsWith(entry.prefix));
        if (match) {
          items.unshift({ label: match.section, isKey: true });
        }
      }

      this.breadcrumbService.setRouteItems(items);
    });
  }

  goBack(items: BreadcrumbItem[]): void {
    if (items.length < 2) return;
    const last = items[items.length - 1];
    if (last.action) {
      last.action();
      return;
    }
    const prev = items[items.length - 2];
    if (prev.url) {
      this.router.navigate([prev.url], { queryParamsHandling: 'preserve' });
    } else {
      window.history.back();
    }
  }

  private buildItems(
    route: ActivatedRouteSnapshot,
    parentUrl: string[],
    items: BreadcrumbItem[],
  ): void {
    const routeUrl = parentUrl.concat(route.url.map((u) => u.path));
    const label = route.data['breadcrumb'];
    const parentLabel = route.parent?.data?.['breadcrumb'] ?? null;

    if (label && !HIDDEN_BREADCRUMBS.has(label) && label !== parentLabel) {
      items.push({ label, url: '/' + routeUrl.join('/'), isKey: true });
    }

    if (route.firstChild) {
      this.buildItems(route.firstChild, routeUrl, items);
    }
  }

  private routeHasFlag(route: ActivatedRouteSnapshot, flag: string): boolean {
    if (route.data[flag]) return true;
    return route.firstChild ? this.routeHasFlag(route.firstChild, flag) : false;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
